import Cookies from 'js-cookie'

export default function getAcceptedCookies() {
  const cookiesList = Cookies.get('cookiesAccepted')
  return cookiesList ? JSON.parse(cookiesList) : null
}
